"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionalError = void 0;
const NotFoundError_1 = require("./NotFoundError");
// TODO this should not extend from NotFoundError.
// a FunctionalError can also be thrown for other use cases
class FunctionalError extends NotFoundError_1.NotFoundError {
    constructor(code, message, item = 'item', msg = `The requested ${item} does not exist`) {
        super(item, msg, [{ code, message }]);
    }
}
exports.FunctionalError = FunctionalError;
